module.exports = __webpack_public_path__ + "img/dashboard-icon.753b4509.svg";